var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNriProperty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 68.5714,
    height: 68.5714,
    rx: 34.2857,
    fill: "#1C3988"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.619 21.5625C37.3563 21.1659 36.0126 20.9521 34.619 20.9521C27.2552 20.9521 21.2856 26.9217 21.2856 34.2855C21.2856 41.6492 27.2552 47.6188 34.619 47.6188C41.9827 47.6188 47.9523 41.6492 47.9523 34.2855C47.9523 31.9984 47.3764 29.8458 46.3618 27.9647M41.2856 25.9521H41.2923M32.6191 47.4699L32.6192 44.532C32.6192 44.3729 32.6762 44.2191 32.7796 44.0983L36.094 40.2313C36.3664 39.9136 36.282 39.4263 35.9187 39.2187L32.1103 37.0424C32.0068 36.9833 31.9212 36.8976 31.8621 36.794L29.3796 32.4436C29.2504 32.2172 29.0011 32.0869 28.7414 32.11L21.3712 32.7664M46.619 26.2855C46.619 29.231 43.9523 31.6188 41.2856 34.2855C38.619 31.6188 35.9523 29.231 35.9523 26.2855C35.9523 23.34 38.3402 20.9521 41.2856 20.9521C44.2311 20.9521 46.619 23.34 46.619 26.2855ZM41.619 25.9521C41.619 26.1362 41.4698 26.2855 41.2856 26.2855C41.1015 26.2855 40.9523 26.1362 40.9523 25.9521C40.9523 25.7681 41.1015 25.6188 41.2856 25.6188C41.4698 25.6188 41.619 25.7681 41.619 25.9521Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNriProperty);
export default __webpack_public_path__ + "static/media/nriProperty.2c38beba445552688257e697a26b8060.svg";
export { ForwardRef as ReactComponent };